import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DoCheck,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { MatMenu } from "@angular/material/menu";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ShipmentSku, ShipmentSkuResolvedPayload } from "src/app/models/shipyard.model";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { WalmartService } from "src/app/services/walmart.service";
import { HeaderService } from "../header/header.service";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { Subject, takeUntil } from "rxjs";
import { NotePopupComponent } from "../note-popup/note-popup.component";
import { MatDialog } from "@angular/material/dialog";
import { LoginModel } from "src/app/models/login.model";
import { CreateTagDialogComponent } from "src/app/modules/settings/create-tag-dialog/create-tag-dialog.component";

@Component({
  selector: "app-shipment-sku",
  templateUrl: "./shipment-sku.component.html",
  styleUrls: ["./shipment-sku.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentSkuComponent implements OnInit,DoCheck,OnDestroy  {
  errorMessage: string;
  @Input() sku: ShipmentSku;
  @Input() skuScanQty: number;
  @Input() highlighted: boolean;
  @Input() active: boolean;
  @Input() isLast: boolean;
  @Input() canBox: boolean;
  @Input() actionMenu: MatMenu;
  @Input() printMenu: MatMenu;
  @Input() addToBoxMenu: MatMenu;
  @Input() box: any;
  @Input() canEdit: any;
  @Input() status: any;
  @Input() showAmazonDetail = false;
  @Input() skuRemove = false;
  @Input() vendorItem = false;
  @Input() shipmentSkuBoxScan: boolean = false;
  @Input() scanComplete: boolean = false;
  @Input() hideQty: boolean = false;
  @Input() boxContentSource:string;
  @Input() showMappedProduct:boolean=false;
  @Input() isAssignSku:boolean = false;
  @Input() userInfo:LoginModel
  @Output() itemSelectedEvent: EventEmitter<any> = new EventEmitter();
  @Output() removeSkuEvent: EventEmitter<any> = new EventEmitter();
  @Output() toggleErrorDialogEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() expDateEvent: EventEmitter<string> = new EventEmitter();
  @Output() skuQtyChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() skuSelected: EventEmitter<any> = new EventEmitter();
  @Output() skuNote : EventEmitter<any> = new EventEmitter();
  showDetail = false;
  invalidSkuQty: boolean = false;
  selectedAccountType: string;
  selectedService;
  useBinLocation:boolean;
  private destroy$ = new Subject<void>();
  @Input()isComplete:boolean= false;

  constructor(public headerService: HeaderService,
    private shipyardService:ShipyardService,
    private walmartService:WalmartService,
    private snackBar:MatSnackBar,
    private cdr: ChangeDetectorRef,
    private dialog : MatDialog) {
    this.headerService.accountSelectedType.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.selectedAccountType = e[0];
      this.selectedService =
      this.selectedAccountType === "Walmart"
        ? this.walmartService
        : this.shipyardService;
    });
  }

  ngDoCheck() {
    this.cdr.markForCheck();
  }

  ngOnInit(): void {
    this.errorMessage = this.sku.shipmentErrors
      ? this.sku.shipmentErrors.map((e) => e.errorMessage).join(" \n ")
      : "";
    this.sku.imageUrl = this.sku?.imageUrl
      ? this.sku.imageUrl
      : "assets/images/No_image.png";
    this.showDetail =
      ((this.showAmazonDetail && this.sku.prep) || this.sku.expirable) &&
      !this.box;
  }

  itemSelected(sku) {
    this.itemSelectedEvent.emit(sku);
  }

  removeSku(sku): void {
    this.removeSkuEvent.emit(sku);
  }

  toggleErrorDialog(open: boolean) {
    this.toggleErrorDialogEvent.emit(open);
  }
  onQtyChange(qty: number) {
    // this.sku.qty = Math.abs(qty);
    if (qty < 1) {
      this.invalidSkuQty = true;
    } else {
      this.invalidSkuQty = false;
    }
    this.sku.qty = qty;
    this.skuQtyChanged.emit(qty);
  }

  selectSku(event){
    let selectedSku : any ={
      sku : this.sku,
      isChecked: event.checked
    }
    this.skuSelected.emit(selectedSku);
  }

  resolvedShipment(){
    const payload:ShipmentSkuResolvedPayload = {
      shipmentDetailId:this.sku.shipmentDetailId,
      isMarkAsResolved:true
    }
    this.selectedService.SetSkuResolved(payload).pipe(takeUntil(this.destroy$)).subscribe((res)=>{
      if(res){
        this.sku.isMarkAsResolved = true;
        this.cdr.detectChanges();
      }
    },(err)=>{
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title:err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
    })
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  
  editNote() {
    const dialog = this.dialog.open(NotePopupComponent, {
      width: "500px",
      data: {
        userNote: this.sku?.note,
        isSkuNote:true,
        sku: this.sku,
        title: this.sku.note ? 'Edit Note' : 'Add Note'
      }
    });
    dialog
      .afterClosed()
      .subscribe((e) => {
        if (e === "Confirm")
          this.skuNote.emit();
      });
  }

  openAllTag(e: MouseEvent) {
    this.dialog.open(CreateTagDialogComponent, {
      backdropClass: "cdk-overlay-transparent-backdrop",
      position: this.getDialogRightPosition(e),
      data: {
        tag: this.sku.getSkuTagsDto,
        title: "Add Tags in Sku",
        isSkuTag: true,
        isTags: true,
        isShipmentSku:true,
      }
    })
  }

  getDialogRightPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      bottom: targetPosision + 500 + "px",
      left: this.sku.length>=4 ? targetPosision.left - 100 + "px" : targetPosision.left + "px", 
      right: targetPosision.right + 150 + "px",
      top: targetPosision.top + 22 + "px",
    };
  }
}
